import {
    Box,
    IconButton,
    Tab,
    Tabs,
    Tooltip,
    Toolbar,
    Typography,
    useMediaQuery
} from "@mui/material";

import {
    CheckBoxOutlineBlankOutlined,
    CloseOutlined,
    ContactMailOutlined,
    DirectionsCarFilledOutlined,
    HailOutlined,
    ScheduleOutlined,
    SendToMobileOutlined,
    TransferWithinAStationOutlined,
    ViewCarouselOutlined
} from "@mui/icons-material";

import VehicleTransferComponent from "./options/VehicleTransferComponent";
import TransferDriverComponent from "./options/TransferDriverComponent";
// import RecordVehicleDriverComponent from "./options/RecordVehicleDriverComponent";
import CustomerHelpDeskComponent from "./options/CustomerHelpDeskComponent";
import DeviceCommandComponent from "./options/DeviceCommandComponent";

import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import CheckListComponent from "./options/CheckListComponent";
import RecordVehicleDriverComponent from "./options/RecordVehicleDriverComponent";
import WorkScheduleComponent from "./options/WorkScheduleComponent";
import BannerComponent from "./options/BannerComponent";
import { userAtom } from "../../../atoms/atoms";
import { MENUS_ITENS, PROFILE_ACESSES } from "../../../consts/consts";

const CustomerHelpPage = ({ isHiddenMenu }: { isHiddenMenu: boolean }) => {
    const currentUser = useRecoilValue(userAtom);
    const isTechnician = currentUser.accessProfile.id === Number(PROFILE_ACESSES.TECHNICIAN);
    const [step, setStep] = useState<number>(0);
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width:650px)");
    const isGridTemplateStep = [2, 4, 5, 6, 7].includes(step);

    // Avisos usa a permissão dedicada do menuitem "Avisos" (id 24, só admin), não a de Suporte ao cliente.
    const bannerPermission = currentUser.permissions.find(
        (permission) => String(permission.optionItem.id) === MENUS_ITENS.BANNERS
    );
    const canViewBanners = bannerPermission?.canView === true;

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        if (isTechnician && newValue > 4) return;
        setStep(newValue);
    };

    useEffect(() => {
        if (location.state?.tab !== undefined) {
            const requestedTab = Number(location.state.tab);
            setStep(Number.isInteger(requestedTab) && requestedTab >= 0 && (!isTechnician || requestedTab <= 4)
                ? requestedTab
                : 0);
        }
    }, [location.state, isTechnician]);

    return (
        <Box
            className="grid-box-out-container tw-flex tw-min-h-screen tw-w-full tw-items-center tw-justify-center tw-bg-transparent tw-p-0.5"
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                minHeight: "100vh",
                background: "transparent",
            }}
        >
            <Box
                className="grid-container support-workspace container container-fluid tw-w-full tw-overflow-hidden tw-rounded-xl tw-border-0 tw-bg-white tw-p-2.5 tw-shadow-none"
                style={{
                    padding: 10,
                    background: "#ffff",
                    transition: "all 0.3s ease-out allow-discrete",
                    width: isMobile ? "100%" : (isHiddenMenu ? "70vw" : "65vw"),
                    borderRadius: 12,
                }}
            >
                {!isGridTemplateStep && (
                    <Toolbar
                        className="grid-header-bar tw-mb-2 tw-mt-2 tw-rounded-xl tw-bg-gtr-sidebar tw-px-3 tw-text-white tw-shadow-sm sm:tw-px-4"
                        sx={{
                            backgroundImage: "linear-gradient(to right, #09414A, #09414A)",
                            minHeight: 64,
                            borderRadius: 3,
                            color: "#fff",
                            position: "relative",
                            width: "100%",
                        }}
                    >
                        <Box className="header-actions tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3">
                            <Box className="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
                                <Box className="tw-flex tw-h-10 tw-w-10 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-bg-white/10">
                                    <ContactMailOutlined />
                                </Box>
                                <Typography
                                    className="tw-truncate"
                                    sx={{ fontFamily: "Prometo", fontWeight: 700, fontSize: { xs: 16, sm: 18 } }}
                                >
                                    Ferramentas
                                </Typography>
                            </Box>
                            <Tooltip title="Fechar" arrow>
                                <IconButton
                                    aria-label="Fechar ferramentas"
                                    onClick={() => window.location.replace("/")}
                                    sx={{
                                        color: "#fff",
                                        transition: "background-color 0.2s ease-out, transform 0.2s ease-out",
                                        "&:hover": {
                                            backgroundColor: "rgba(255, 255, 255, 0.12)",
                                            transform: "translateY(-1px)",
                                        },
                                    }}
                                >
                                    <CloseOutlined />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Toolbar>
                )}

                <Box
                    className="support-content-surface tw-flex tw-min-h-0 tw-w-full tw-items-start tw-justify-center tw-overflow-visible tw-rounded-xl tw-bg-white tw-py-1"
                    role="tabpanel"
                    id={`scrollable-force-tabpanel-${step}`}
                    aria-labelledby={`scrollable-force-tab-${step}`}
                    style={{
                        width: "100%",
                        borderRadius: 5,
                        backgroundColor: "#ffff",
                        fontFamily: "Prometo",
                        minHeight: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start"
                    }}
                >
                    {step === 0 && (
                        <VehicleTransferComponent
                            initialMode={location.state?.transferMode}
                            initialSourceCustomerId={location.state?.sourceCustomerId}
                            initialVehicle={location.state?.vehicleId ? {
                                id: location.state.vehicleId,
                                vehiclePlate: location.state.vehiclePlate,
                                departmentId: location.state.departmentId,
                                secretaryId: location.state.secretaryId,
                            } : undefined}
                        />
                    )}
                    {step === 1 && <TransferDriverComponent />}
                    {step === 2 && <CustomerHelpDeskComponent />}
                    {step === 3 && <DeviceCommandComponent />}
                    {step === 4 && <CheckListComponent />}
                    {!isTechnician && step === 5 && <RecordVehicleDriverComponent />}
                    {!isTechnician && step === 6 && <WorkScheduleComponent />}
                    {step === 7 && canViewBanners && <BannerComponent permission={bannerPermission} />}
                </Box>

                <Toolbar
                    className="grid-header-bar tw-mt-2 tw-rounded-xl tw-bg-gtr-sidebar tw-text-white tw-shadow-sm"
                    sx={{
                        display: "flex",
                        backgroundImage: "linear-gradient(to right, #09414A , #09414A)",
                        fontFamily: "Prometo",
                        minHeight: 48,
                        borderRadius: 3,
                        mb: 1,
                        color: "#fff",
                        px: 1,
                    }}
                >
                    <Box
                        className="header-actions"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            overflowX: "auto",
                            width: "100%",
                        }}
                    >
                        <Tabs
                            value={step}
                            onChange={handleChange}
                            variant={isMobile ? "scrollable" : "fullWidth"}
                            scrollButtons={isMobile ? "auto" : false}
                            allowScrollButtonsMobile
                            indicatorColor="primary"
                            textColor="inherit"
                            sx={{
                                fontFamily: "Prometo",
                                color: "#fff",
                                width: "100%",
                                "& .MuiTabs-indicator": { backgroundColor: "#00B700", height: 3 },
                                "& .MuiTab-root": { minHeight: 58, borderRadius: 2, transition: "background-color 200ms ease, color 200ms ease" },
                                "& .Mui-selected": { backgroundColor: "rgba(255, 255, 255, 0.10)" },
                            }}
                        >
                            <Tab
                                value={0}
                                icon={<DirectionsCarFilledOutlined />}
                                aria-label="device-info" label={isMobile ? "" : "Transferência de veículo"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                            />

                            <Tab
                                value={1}
                                icon={<TransferWithinAStationOutlined />}
                                aria-label="device-info" label={isMobile ? "" : "Transferência de motorista"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                            />

                            <Tab
                                value={2}
                                icon={<ContactMailOutlined />}
                                aria-label="device-info" label={isMobile ? "" : "Solicitações do cliente"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                            />

                            <Tab
                                value={3}
                                icon={<SendToMobileOutlined />}
                                aria-label="device-info" label={isMobile ? "" : "Envio de comando"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                            />

                            <Tab
                                value={4}
                                icon={<CheckBoxOutlineBlankOutlined />}
                                aria-label="device-info" label={isMobile ? "" : "Checklist do veículo"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                            />

                            {!isTechnician && <Tab
                                value={5}
                                icon={<HailOutlined />}
                                aria-label="device-info" label={isMobile ? "" : "Acesso do condutor"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                            />}

                            {!isTechnician && <Tab
                                value={6}
                                icon={<ScheduleOutlined />}
                                aria-label="device-info" label={isMobile ? "" : "Escalas de trabalho"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                            />}

                            {canViewBanners && (
                                <Tab
                                    value={7}
                                    icon={<ViewCarouselOutlined />}
                                    aria-label="device-info" label={isMobile ? "" : "Avisos"} sx={{ border: "none", fontSize: 8, fontFamily: "Prometo" }}
                                />
                            )}
                        </Tabs>
                    </Box>
                </Toolbar>
            </Box>
        </Box>
    );
};

export default CustomerHelpPage;
